module.exports = __webpack_public_path__ + "img/switch_on.cde16519.svg";